<div fxLayout="row" fxLayoutGap="36px" fxLayoutAlign="space-between center">
    <standing-boy fxHide.xs></standing-boy>
    <feedback (skip)="skip()"></feedback>
</div>